export default __webpack_public_path__ + "static/media/mTop_1_p2.7815a6c2.jpeg";